// General funcitons

// Functions that sums array
export const sum = (arr) => arr.reduce((a,b) => a + b, 0)